import { Box, IconButton, MenuItem, Paper, Select, Stack, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: DividerBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const DividerBlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                        Divider Block
                    </Typography>
                    <Stack spacing={2}>
                        <TextField
                            label="Thickness"
                            value={block.content.thickness || "1px"}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    thickness: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            helperText="e.g., 1px, 2px, 0.25rem"
                        />
                        <TextField
                            label="Color"
                            value={block.content.color || "#cccccc"}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    color: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            helperText="e.g., #cccccc, rgba(0,0,0,0.1)"
                        />
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="body2">Style:</Typography>
                            <Select
                                value={block.content.style || "solid"}
                                onChange={(e) =>
                                    onChange({
                                        ...block.content,
                                        style: e.target.value,
                                    })
                                }
                                size="small"
                            >
                                <MenuItem value="solid">Solid</MenuItem>
                                <MenuItem value="dashed">Dashed</MenuItem>
                                <MenuItem value="dotted">Dotted</MenuItem>
                            </Select>
                        </Stack>
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default DividerBlockEditor;
